import { render } from "./Forbidden.vue?vue&type=template&id=ae0d1482"
const script = {}

import "./Forbidden.vue?vue&type=style&index=0&id=ae0d1482&lang=css"
script.render = render

export default script